import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { CITIES } from "../lib/site";

export default function CityStrip() {
  return (
    <section data-testid="city-strip" className="bg-obsidian py-24 text-cream md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal className="mb-12 max-w-2xl">
          <p className="text-xs uppercase tracking-[0.25em] text-gold">Where we install</p>
          <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight md:text-5xl">
            Dedicated solar teams across the Tricity & Himachal.
          </h2>
        </Reveal>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {CITIES.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.05}>
              <Link to={`/solar/${c.slug}`} data-testid={`citystrip-${c.slug}`}
                className="group flex h-full flex-col justify-between rounded-3xl border border-white/10 bg-white/5 p-6 transition-colors hover:border-gold/50 hover:bg-white/[0.08]">
                <div className="flex items-start justify-between">
                  <MapPin className="h-5 w-5 text-gold" />
                  <ArrowUpRight className="h-5 w-5 text-cream/40 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold" />
                </div>
                <div className="mt-10">
                  <h3 className="font-heading text-2xl font-bold">Solar in {c.name}</h3>
                  <p className="mt-1 font-mono text-xs uppercase tracking-widest text-cream/50">{c.state}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
